module.exports = __webpack_public_path__ + "img/banner3_4.873f6cd6.png";